import { NavLink } from "react-router-dom";
import { useCan } from "@/auth/permissions";

/** 系统设置子页 tab（通用设置 / 通知配置）· 顶部切换入口。 */
const TABS = [
  { to: "/admin/settings", label: "⚙ 通用设置", end: true },
  { to: "/admin/settings/notifications", label: "🔔 通知配置", end: false },
  { to: "/admin/settings/confirmation-template", label: "📄 出团确认单模板", end: false },
  { to: "/admin/settings/cancellation-policy", label: "❌ 取消条款", end: false },
];
// AICFG-1 · 只对 owner / tech_admin 显示——其它角色直接访问该地址也会被页面自己挡住
// （不发请求，照 RecycleBinPage 的写法），这里只是不给入口，双保险。
const AI_TAB = { to: "/admin/settings/ai", label: "🤖 AI 配置", end: false };

// IMGLIB-1 · 地点清单：运营经理 / 老板 / 技术管理员（media.library.manage）；运营经理没有其它设置标签的权限，只看到这一个
const PLACES_TAB = { to: "/admin/settings/places", label: "📍 地点清单", end: false };

// PAY-1 · 客服与收款：客服（老板 / 技术管理员可改）+ 收款码卡片（老板 + 技术管理员，卡片内自己判权限）
const SERVICE_TAB = { to: "/admin/settings/site-service", label: "💬 客服与收款", end: false };


/** 页签名后面带「新」角标的页签 */
const NEW_TABS: string[] = [AI_TAB.to, PLACES_TAB.to, SERVICE_TAB.to];

export function SettingsTabs() {
  const canSeeAiTab = useCan("system.ai.view");
  const canSeeGeneral = useCan("system.settings.view");
  const canSeePlaces = useCan("media.library.manage");
  const tabs = [...(canSeeGeneral ? [...(canSeeAiTab ? [...TABS, AI_TAB] : TABS), SERVICE_TAB] : []), ...(canSeePlaces ? [PLACES_TAB] : [])];
  return (
    <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `border-b-2 px-4 py-2 text-[13px] font-medium ${
              isActive ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500 hover:text-slate-700"
            }`
          }
        >
          {t.label}
          {NEW_TABS.includes(t.to) && (
            <span className="ml-1 rounded bg-violet-600 px-1.5 py-0.5 text-[10.5px] font-bold text-white">新</span>
          )}
        </NavLink>
      ))}
    </div>
  );
}
